export default __webpack_public_path__ + "static/media/logo-google.ff2bf7da.svg";